// extracted by mini-css-extract-plugin
export var actionButton = "_dv-0";
export var attachmentLine = "_dv-1";
export var fileInput = "_dv-2";
export var fileUploadWrapper = "_dv-4";
export var footer = "_dv-3";
export var modalContent = "_dv-5";
export var paperclip = "_dv-6";
export var quillEditor = "_dv-7";